import { SubDepartmentState, SubDepartmentTypes } from '../actions/subDepartments/subDepartments.d';
import {
  FETCH_SUB_DEPARTMENTS_COMPLETED,
  FETCH_SUB_DEPARTMENTS_ERROR,
  FETCH_SUB_DEPARTMENTS_STARTED,
  UPDATE_SUB_DEPARTMENTS_CURRENT_PAGE,
  UPDATE_SUB_DEPARTMENTS_PAGE_SIZE,
  ADD_SUB_DEPARTMENT_SEARCH,
  CLEAR_SUB_DEPARTMENT_SEARCH,
  UPDATE_SUB_DEPARTMENTS_COLUMN_SORT,
  CLEAR_SUB_DEPARTMENT_COLUMN_SORT,
} from 'redux/actionTypes/subDepartments';

const INITIAL_STATE: SubDepartmentState = {
  data: [],
  error: false,
  submitted: false,
  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
    totalPages: 0,
    nextPage: 0,
    prevPage: null,
    isFirstPage: false,
    isLastPage: false,
    startAt: null,
    endAt: null,
  },
  q: '',
  sorted: [],
};

function subDepartmentsReducer(
  state = INITIAL_STATE,
  action: SubDepartmentTypes,
): SubDepartmentState {
  switch (action.type) {
    case FETCH_SUB_DEPARTMENTS_STARTED: {
      return {
        ...state,
        submitted: true,
      };
    }

    case FETCH_SUB_DEPARTMENTS_COMPLETED: {
      return {
        ...state,
        ...action.payload,
        submitted: false,
      };
    }

    case FETCH_SUB_DEPARTMENTS_ERROR: {
      return {
        ...state,
        error: true,
        submitted: false,
      };
    }

    case UPDATE_SUB_DEPARTMENTS_CURRENT_PAGE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.currentPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case UPDATE_SUB_DEPARTMENTS_PAGE_SIZE: {
      const pagination = {
        ...state.pagination,
      };
      pagination.perPage = action.payload;
      return {
        ...state,
        pagination: { ...pagination },
      };
    }

    case ADD_SUB_DEPARTMENT_SEARCH: {
      return {
        ...state,
        q: action.payload,
      };
    }

    case CLEAR_SUB_DEPARTMENT_SEARCH: {
      return {
        ...state,
        q: '',
      };
    }

    case UPDATE_SUB_DEPARTMENTS_COLUMN_SORT: {
      return {
        ...state,
        sorted: action.payload,
      };
    }

    case CLEAR_SUB_DEPARTMENT_COLUMN_SORT: {
      return {
        ...state,
        sorted: [],
      };
    }

    default:
      return state;
  }
}

export default subDepartmentsReducer;
